import { graphql } from "gql";

const INTERNAL_ADMIN_PREVIEW_DISTRIBUTION_GROUP_MEMBERSHIP_QUERY = graphql(`
  query internalAdminPreviewDistributionGroupMembership(
    $organizationId: ID!
    $input: AdminPreviewDistributionGroupMembershipInput!
  ) {
    internalAdminPreviewDistributionGroupMembership(
      organizationId: $organizationId
      input: $input
    ) {
      userIdList
      emailUserIdList
    }
  }
`);

export default INTERNAL_ADMIN_PREVIEW_DISTRIBUTION_GROUP_MEMBERSHIP_QUERY;
